import { useEffect, useState } from "react";
import { api } from "../api/client";

interface AgentSetting {
  product_id: string;
  name: string;
  system_prompt?: string;
  agent_id?: string;
}

export function AgentSettingsPage() {
  const [settings, setSettings] = useState<AgentSetting[]>([]);
  const [edited, setEdited] = useState<Record<string, AgentSetting>>({});
  const [saved, setSaved] = useState<string | null>(null);

  function load() {
    void api.get<AgentSetting[]>("/api/settings/agents").then(setSettings);
  }
  useEffect(load, []);

  function update(productId: string, patch: Partial<AgentSetting>) {
    setEdited((prev) => ({
      ...prev,
      [productId]: { ...settings.find((s) => s.product_id === productId)!, ...prev[productId], ...patch },
    }));
  }

  async function save(productId: string) {
    const body = edited[productId];
    if (!body) return;
    await api.put(`/api/settings/agents/${productId}`, {
      system_prompt: body.system_prompt,
      agent_id: body.agent_id || undefined,
    });
    setSaved(productId);
    setTimeout(() => setSaved(null), 1500);
    load();
  }

  return (
    <div>
      <h2>Agent Settings</h2>
      <p className="muted">
        Per-product system prompt and optional Managed Agent override. Prompts are injected as a
        system message at the start of each conversation session.
      </p>
      {settings.map((s) => {
        const cur = edited[s.product_id] ?? s;
        return (
          <div className="card" key={s.product_id}>
            <h3>{s.name}</h3>
            <div className="field">
              <label>System prompt (product-specific)</label>
              <textarea
                rows={4}
                value={cur.system_prompt ?? ""}
                onChange={(e) => update(s.product_id, { system_prompt: e.target.value })}
              />
            </div>
            <div className="field">
              <label>Managed Agent id override (optional)</label>
              <input
                value={cur.agent_id ?? ""}
                onChange={(e) => update(s.product_id, { agent_id: e.target.value })}
                placeholder="agent_… (defaults to GENERAL_SUPPORT_AGENT_ID)"
              />
            </div>
            <button className="btn" onClick={() => save(s.product_id)}>
              {saved === s.product_id ? "Saved ✓" : "Save"}
            </button>
          </div>
        );
      })}
    </div>
  );
}
